import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchGrafanaQuery,
  getDashboardQueryDetails,
  getDashboardQueryDetailsWithInterval,
  getUserGrafanaDashboardQuery,
} from "../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import {
  addGrafanaMutation,
  updateGrafanaMutation,
  createNewUserGrafanaDashboard,
  renameUserGrafanaDashboard,
  deleteUserGrafanaDashboard,
} from "../../graphql/mutations";
import {
  handleAllComponentsLoader,
  handleLoading,
  setDashboardState,
  setUserGrafanaDashboardState,
} from "../slices/grafanaChartsSlice";
import { ChangeServiceRequest } from "./commonThunk";
import {
  devApi,
  devApiMeasurementService,
  prodApi,
  prodApiMeasurementService,
  qaApi,
  qaApidevApiMeasurementService,
} from "../../aws-export";
import { updateAllCharts } from "../../components/Grafana/chartFunctions";
import { sendGAEvent } from "./AddGAEvent";
import GrafanaClient from "../../config/grafanaClient";
import { setGrafanaFullData } from "../slices/newGrafanaSlice";
import {
  notificationFail,
  notificationSuccess,
} from "../slices/notificationSlice";

export const getGrafanaDataThunk = createAsyncThunk(
  "getGrafanaData",
  async (_request: any, { dispatch }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    dispatch(handleLoading(true));
    const getReq = {
      tenantCode: _request.code,
      tenantId: _request.id,
    };

    try {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
              ? prodApi
              : devApi,
        })
      );

      const grafanaData = (await API.graphql({
        ...graphqlOperation(fetchGrafanaQuery, getReq),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as any;

      if (grafanaData.data.getGrafana.length == 0) {
        dispatch(handleLoading(false));
        return {};
      } else if (grafanaData?.data?.getGrafana?.length !== 0) {
        const info = grafanaData?.data?.getGrafana?.map((obj: any) => ({
          ...obj,
          grafana_data: JSON.parse(obj.grafana_data),
        }));

        if (info?.length > 0) {
          const chartData = info[0];
          const id = localStorage.getItem("dashboardId");

          let dashboardItem;
          if (id) {
            const dashboard = info[0].grafana_data.find(
              (item: any) => item.id == JSON.parse(id)
            );
            dashboardItem = dashboard.id ? dashboard : info[0].grafana_data[0];
          } else {
            dashboardItem = info[0].grafana_data[0];
          }

          const dashboardIndex = 0;
          dispatch(handleAllComponentsLoader(true));
          dispatch(setDashboardState(dashboardItem));

          updateAllCharts({
            chartData,
            dispatch,
            dashboardItem,
            dashboardIndex,
            locationItem: _request.location,
            date: _request.date,
          });
          return info[0];
        } else {
          dispatch(setDashboardState({}));
          return {};
        }
      }
    } catch (error) {
      dispatch(handleLoading(false));
    }
  }
);

export const addGrafanaThunk = createAsyncThunk(
  "addGrafana",
  async (_request: any, { dispatch }) => {
    const addReq = {
      username: _request.username,
      tenant_code: _request.tenant_code,
      grafana_data: _request.grafana_data,
    };
    try {
      const data = (await API.graphql({
        ...graphqlOperation(addGrafanaMutation, { addGrafana: addReq }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };
      dispatch(
        getGrafanaDataThunk({
          code: _request.tenant.tenantCode,
          id: _request.tenant.tenantId,
        })
      );
    } catch (error) {}
  }
);

export const updateGrafanaThunk = createAsyncThunk(
  "updateGrafana",
  async (_request: any, { dispatch }) => {
    try {
      const updateReq = {
        pk: _request.pk,
        username: _request.username,
        tenant_code: _request.tenant_code,
        grafana_data: _request.grafana_data,
      };

      const grafanaData = (await API.graphql({
        ...graphqlOperation(updateGrafanaMutation, {
          updateGrafana: updateReq,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; erros: any[] };
      // dispatch(sendGAEvent({
      //   category:'update',
      //   action:'Update/add Chart',
      //   label:"Dashboard updated",
      //   value:null
      // }))
      return grafanaData;
    } catch (error) {}
  }
);

export const updateLayoutThunk = createAsyncThunk(
  "updateLayout",
  async (_request: any, { dispatch }) => {
    try {
      const updateReq = {
        pk: _request.pk,
        username: _request.username,
        tenant_code: _request.tenant_code,
        grafana_data: _request.grafana_data,
      };

      const grafanaData = (await API.graphql({
        ...graphqlOperation(updateGrafanaMutation, {
          updateGrafana: updateReq,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; erros: any[] };
    } catch (error) {}
  }
);

export const fetchSubstanceGraphData = createAsyncThunk(
  "fetch/grafana/data",
  async (_request: any, { dispatch }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
  }
);

export const dashBordDetailsQuery: any = createAsyncThunk(
  "new/dashboard",
  async (_request: any, { dispatch }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    try {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApidevApiMeasurementService
              : loginwithtype === "prod"
              ? prodApiMeasurementService
              : devApiMeasurementService,
        })
      );
      let getDashboardQerData =
        _request.interval !== ""
          ? getDashboardQueryDetailsWithInterval
          : getDashboardQueryDetails;
      const getDashboard = (await API.graphql(
        graphqlOperation(getDashboardQerData, _request)
      )) as { data: any; errors: any[] };
      await dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
              ? prodApi
              : devApi,
        })
      );
      return getDashboard.data.getDashboardQueryDetails.records;
      // .filter((v:any,i:any)=>i%10==0);
    } catch (error) {
      await dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
              ? prodApi
              : devApi,
        })
      );
      return error;
    }
  }
);

export const addUserGrafanaDashboardThunk = createAsyncThunk(
  "addUserGrafanaDashboard",
  async (_request: any, { dispatch }) => {
    try {
      const data = (await API.graphql({
        ...graphqlOperation(createNewUserGrafanaDashboard, {
          addOrUpdateUserGrafanaDashboard: _request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };

      if (data.data.addOrUpdateUserGrafanaDashboard.success === "false") {
        dispatch(notificationFail(data.data.addOrUpdateUserGrafanaDashboard.message));
      } else {
        dispatch(
          notificationSuccess(data.data.addOrUpdateUserGrafanaDashboard.message)
        );
      }
    } catch (error) {}
  }
);

export const getUserGrafanaDashboardThunk = createAsyncThunk(
  "getUserGrafanaDashboard",
  async (_request: any, { dispatch }) => {
    try {
      const grafanaData = (await API.graphql({
        ...graphqlOperation(getUserGrafanaDashboardQuery, _request),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as any;

      //Sort Dashboard data
      const grafanaAllDashboard: any =
        grafanaData?.data?.getUserGrafanaDashboard;
      grafanaAllDashboard.sort((a: any, b: any) => {
        return (
          new Date(b?.created_at).getTime() - new Date(a?.created_at).getTime()
        );
      });

      dispatch(setUserGrafanaDashboardState(grafanaAllDashboard));
    } catch (error) {
      dispatch(handleLoading(false));
    }
  }
);

export const deleteUserGrafanaDashboardThunk = createAsyncThunk(
  "deleteUserGrafanaDashboardNew",
  async (_request: any, { dispatch }) => {
    try {
      const deleteGrafana = (await API.graphql({
        ...graphqlOperation(deleteUserGrafanaDashboard, {
          deleteUserGrafanaDashboard: _request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as any;

      if (deleteGrafana.data.deleteUserGrafanaDashboard.success === "true") {
        dispatch(notificationSuccess(deleteGrafana.data.deleteUserGrafanaDashboard.message));
      }

    } catch (error) {
      dispatch(handleLoading(false));
    }
  }
);

export const RenameUserGrafanaDashboardThunk = createAsyncThunk(
  "renameUserGrafanaDashboard",
  async (_request: any, { dispatch }) => {
    try {
      const data = (await API.graphql({
        ...graphqlOperation(renameUserGrafanaDashboard, {
          renameUserGrafanaDashboard: _request?.params,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };

      if (data.data.renameUserGrafanaDashboard.success === "false") {
        dispatch(notificationFail(data.data.renameUserGrafanaDashboard.message));
      } else {
        dispatch(setUserGrafanaDashboardState(_request?.userGrafanaDashboard)); //Update title in reducer state
        dispatch(
          notificationSuccess(data.data.renameUserGrafanaDashboard.message)
        );
      }
    } catch (error) {}
  }
);
